import { isEmailValid } from "@/utils/email";
import { useCallback, useState } from "react";
import { track } from "@/utils/mixpanel";
// import { signup, updateRevenueCat, cancelSubscription } from "@/utils/api";

export const useStripePaymentConfirmation = ({
    branchUrl,
    userId,
    withTrial,
    isNewFlow,
    subscriptionId,
    cancelSubscriptionId,
    // updateCustomer,
    customerId,
    stripe,
    elements,
    email: initialEmail,
}) => {
    const [errorMessage, setErrorMessage] = useState('');

    const confirmPayment = useCallback(async (email = initialEmail) => {
        if (!stripe || !elements) {
            console.error('Stripe.js has not loaded.', { elements, stripe });
            setErrorMessage('An error occurred. Please try again. (e101)');
            return;
        }

        if (!email || !isEmailValid(email)) {
            console.error('Please fill in all fields.', { email });
            setErrorMessage('Please fill in all fields.');
            return;
        }

        if (!subscriptionId) {
            console.error('Subscription ID is required.', { subscriptionId });
            setErrorMessage('An error occurred. Please try again. (e105)');
            return;
        }

        const url = new URL(isNewFlow ? window.location.href : process.env.NEXT_PUBLIC_APP_API_DOMAIN);
        url.pathname = isNewFlow ? "/quiz/checkout-redirect" : "/checkout-redirect";
        email && url.searchParams.append("email", email);
        branchUrl && url.searchParams.append("link", branchUrl);
        userId && url.searchParams.append("user_id", userId);
        subscriptionId && url.searchParams.append("subscription_id", subscriptionId);
        customerId && url.searchParams.append("customer_id", customerId);
        cancelSubscriptionId && url.searchParams.append("cancel_subscription_id", cancelSubscriptionId);
        url.searchParams.append("success", "true");

        const returnUrl = url.toString();

        let error = null;
        let paymentConfirmationPromise = null;

        if (withTrial) {
            paymentConfirmationPromise = stripe.confirmSetup({
                elements,
                confirmParams: {
                    return_url: returnUrl,
                },
            })
        } else {
            paymentConfirmationPromise = stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: returnUrl,
                    payment_method_data: {
                        billing_details: { email }
                    }
                },
            })
        }
        try {
            const paymentConfirmation = await paymentConfirmationPromise;

            if (paymentConfirmation.error) {
                if (paymentConfirmation.error.type === "card_error" ||
                    paymentConfirmation.error.type === "validation_error") {
                    track("stripe_payment_failed", {
                        error_type: paymentConfirmation.error.type,
                        error: paymentConfirmation.error.message,
                        email
                    });
                    console.error("payment failed", paymentConfirmation.error);
                    setErrorMessage("An error occurred. Please try again. (e102)");
                    return;
                }

                console.error("payment failed", paymentConfirmation.error);
                setErrorMessage("An error occurred. Please try again. (e103)");
                return;
            }
        } catch (error) {
            console.error("payment failed", error);
            setErrorMessage("An error occurred. Please try again. (e104)");
        }

        return { error };
    }, [
        stripe,
        branchUrl,
        userId,
        initialEmail,
        withTrial,
        elements,
        isNewFlow,
        subscriptionId,
        cancelSubscriptionId,
    ]);

    return { confirmPayment, errorMessage };
}
